import { useState, useEffect } from "react";
import { MentorCard } from "./MentorCard";

function MentorSlider({ mentors }) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const perPage = isMobile ? 2 : 5;
  const [visibleStart, setVisibleStart] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const [paused, setPaused] = useState(false);
  const total = mentors.length;

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };
    window.addEventListener("resize", handleResize, { passive: true });
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setVisibleStart(prev => (prev + perPage) % total);
      setAnimKey(k => k + 1);
    }, 2500);
    return () => clearInterval(timer);
  }, [total, perPage, paused]);

  const visible = [];
  for (let i = 0; i < perPage; i++) {
    visible.push(mentors[(visibleStart + i) % total]);
  }

  const pageCount = Math.ceil(total / perPage);
  const currentPage = Math.floor(visibleStart / perPage);

  const goNext = () => {
    setVisibleStart(prev => (prev + perPage) % total);
    setAnimKey(k => k + 1);
  };
  const goPrev = () => {
    setVisibleStart(prev => (prev - perPage + total) % total);
    setAnimKey(k => k + 1);
  };

  return (
    <div className="w-full" style={{ position: "relative" }} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <style>{`
        @keyframes mentorFadeIn {
          from { opacity: 0; transform: translateY(16px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
        .mentor-card { animation: mentorFadeIn 0.45s cubic-bezier(0.22,1,0.36,1) forwards; opacity: 0; }
        .mentor-card:nth-child(1) { animation-delay: 0ms; }
        .mentor-card:nth-child(2) { animation-delay: 60ms; }
        .mentor-card:nth-child(3) { animation-delay: 120ms; }
        .mentor-card:nth-child(4) { animation-delay: 180ms; }
        .mentor-card:nth-child(5) { animation-delay: 240ms; }
      `}</style>

      {/* Cards — full width, arrows float outside */}
      <div style={{ position: "relative" }}>

        {/* Left arrow — floats left of grid */}
        <button
          onClick={goPrev}
          aria-label="Previous"
          style={{
            position: "absolute",
            left: isMobile ? "-14px" : "-28px",
            top: "38%",
            transform: "translateY(-50%)",
            zIndex: 20,
            width: isMobile ? 36 : 48,
            height: isMobile ? 36 : 48,
            borderRadius: "50%",
            background: "#1e3a8a",
            border: "none",
            color: "#fff",
            boxShadow: "0 4px 18px rgba(30,58,138,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "background 0.2s, transform 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#2563eb"}
          onMouseLeave={e => e.currentTarget.style.background = "#1e3a8a"}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 20, height: 20 }}>
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        {/* Cards grid — full width */}
        <div
          key={animKey}
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(5, 1fr)",
            gap: isMobile ? "12px" : "20px",
            width: "100%",
          }}
        >
          {visible.map((m, idx) => (
            <MentorCard key={m.linkedin || m.name?.az || idx} m={m} isMobile={isMobile} />
          ))}
        </div>

        {/* Right arrow — floats right of grid */}
        <button
          onClick={goNext}
          aria-label="Next"
          style={{
            position: "absolute",
            right: isMobile ? "-14px" : "-28px",
            top: "38%",
            transform: "translateY(-50%)",
            zIndex: 20,
            width: isMobile ? 36 : 48,
            height: isMobile ? 36 : 48,
            borderRadius: "50%",
            background: "#1e3a8a",
            border: "none",
            color: "#fff",
            boxShadow: "0 4px 18px rgba(30,58,138,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "background 0.2s, transform 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#2563eb"}
          onMouseLeave={e => e.currentTarget.style.background = "#1e3a8a"}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 20, height: 20 }}>
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>

      </div>

      {/* Pagination dots */}
      <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 28 }}>
        {Array.from({ length: pageCount }).map((_, i) => (
          <button
            key={i}
            onClick={() => { setVisibleStart(i * perPage); setAnimKey(k => k + 1); }}
            style={{
              height: 8,
              width: currentPage === i ? 24 : 8,
              borderRadius: 999,
              background: currentPage === i ? "#1e3a8a" : "#d1d5db",
              border: "none",
              cursor: "pointer",
              transition: "all 0.3s",
              padding: 0,
            }}
          />
        ))}
      </div>
    </div>
  );
}

// ─── Language Dropdown ───────────────────────────────────────────────────────

export { MentorSlider };
